"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function LocationBlueSvg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 68, height: 43, viewBox: "0 0 68 43" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { id: `locationblue-${id0}`, d: "M8 .833c4.142 0 7.5 3.38 7.5 7.55 0 2.779-2.5 6.374-7.5 10.784C3 14.757.5 11.162.5 8.382.5 4.213 3.858.833 8 .833zM8 2.5c-3.22 0-5.833 2.631-5.833 5.882 0 1.979 1.91 4.89 5.833 8.537 3.922-3.648 5.833-6.558 5.833-8.537C13.833 5.132 11.22 2.5 8 2.5zM8 5c1.84 0 3.333 1.492 3.333 3.333 0 1.841-1.492 3.334-3.333 3.334-1.84 0-3.333-1.493-3.333-3.334C4.667 6.493 6.159 5 8 5zm0 1.667c-.92 0-1.667.746-1.667 1.666C6.333 9.253 7.08 10 8 10s1.667-.746 1.667-1.667c0-.92-.747-1.666-1.667-1.666z" })),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", null,
                react_1.default.createElement("g", null,
                    react_1.default.createElement("g", null,
                        react_1.default.createElement("g", null,
                            react_1.default.createElement("g", null,
                                react_1.default.createElement("g", { transform: "translate(-976 -410) translate(848 20) translate(31 129) translate(0 260) translate(96) translate(1 1)" },
                                    react_1.default.createElement("rect", { width: 54, height: 14, x: 7, y: 15, fill: "#597EFF", fillRule: "nonzero", opacity: 0.1, rx: 2 }),
                                    react_1.default.createElement("g", { opacity: 0.6, transform: "translate(43 12)" },
                                        react_1.default.createElement("use", { fill: "#597EFF", fillRule: "nonzero", xlinkHref: `#locationblue-${id0}` })),
                                    react_1.default.createElement("path", { fill: "#597EFF", fillRule: "nonzero", d: "M12 21H38V23H12z", opacity: 0.4 })))))))));
}
function LocationBlue(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(LocationBlueSvg, Object.assign({}, svgProps)));
}
exports.default = LocationBlue;
//# sourceMappingURL=LocationBlue.js.map